<template>
  <div class="out_box">
    <div class="user_balance">积分余额：<span>{{userInfo?.beans || 0}}</span></div>
    <div class="meal_box">
      <div v-for="item in productList" class="meal_item" :class="{active: selectMeal.id == item.id}" @click="changeMeal(item)">
        <!-- <div>{{ item.name }}</div> -->
        <div class="meal_count">
          <img :src="require(`@/assets/images/point${selectMeal.id == item.id ? '-active' : ''}.png`)">
          {{ item.beans }}
        </div>
        <div class="meal_price">￥{{ item.price }} <span>元</span></div>
        <div class="meal_oprice" v-if="item.origin_price">￥{{ item.origin_price }}</div>
      </div>
    </div>
    <div class="pay_title">支付</div>
    <div class="pay_box">
      <img :src="payCodeUrl" class="pay_code">
      <div class="pay_info">
        <div class="pay_price">
          实付: 
          <span style="margin-left: 4px;">
            <span style="font-size: 16px;">￥</span>
            {{ selectMeal?.price }}
            <span style="font-size: 20px;">元</span>
          </span>
        </div>
        <div>
          <img src="@/assets/images/alipay.png">
          <img src="@/assets/images/wechat.png">
          请使用微信/支付宝支付
        </div>
        <div class="pay_agree">支付即同意《会员服务协议》 《会员支付规则》</div>
      </div>
    </div>
    <div class="doulist_box">
      <div>
        <span class="dou_btn" :class="{dou_btnactive: beansType == 1}" @click="changeType(1)">积分充值明细</span>
        <span class="dou_btn" :class="{dou_btnactive: beansType == 2}" @click="changeType(2)">积分使用明细</span>
      </div>
      <div class="table_box" style="margin-top: 28px;">
        <div class="table_head">积分变动内容</div>
        <div class="table_head">积分发生时间</div>
        <div class="table_head">积分变化数量</div>
        <!-- <div class="table_head">积分过期时间</div> -->
        <div class="table_head">积分余额</div>
      </div>
      <div class="table_box" v-for="item in beansList">
        <div class="table_body">{{item.reason}}</div>
        <div class="table_body">{{item.create_time}}</div>
        <div class="table_body">{{ beansType == 1 ? '+' : '-' }} {{item.amount}}</div>
        <!-- <div class="table_body">{{item.expire_time || '--'}}</div> -->
        <div class="table_body">{{item.balance}}</div>
      </div>
      <div v-if="beansList.length == 0" class="dou_nomore">暂无记录</div>
      <el-pagination
        style="width: 80%;"
        hide-on-single-page
        :page-size="searchForm.limit"
        :page-count="totalPage"
        @current-change="handleCurrentChange"
        layout="->, prev, pager, next"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { paymentGetProduct, paymentGetProductUrl, paymentGetBeans } from '@/api/user'
import QRCode from "qrcode"
export default {
  name: "accountManage",
  data () {
    return {
      selectMeal: null,
      productList: [],
      payCodeUrl: '',
      beansType: 1,
      beansList: [],
      tableTotal: 0,
      totalPage: 0,
      searchForm: {
        page: 1,
        limit: 8
      }
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
  },
  created() {
    paymentGetProduct().then(res => {
      this.selectMeal = res.data.list[0]
      this.productList = res.data.list
      this.getPayUrl(res.data.list[0].id)
    })

    this.getBeansList()
  },
  methods:{
    changeMeal(item) {
      this.selectMeal = item
      this.getPayUrl(item.id)
    },
    getPayUrl(id) {
      paymentGetProductUrl({product_id: id}).then(res => {
        this.generateQRCode(res.data.url)
      })
    },
    async generateQRCode(url) {
      try {
        this.payCodeUrl = await QRCode.toDataURL(url)
      }catch(error) {
        console.error('Failed to generate QR code:', error)
      }
    },
    changeType(type) {
      if(this.beansType != type) {
        this.beansType = type
        this.getBeansList()
      }
    },
    handleCurrentChange(val){
      this.searchForm.page = val
      this.getBeansList()
    },
    getBeansList() {
      paymentGetBeans(this.beansType, this.searchForm).then(res => {
        this.beansList = res.data.list
        this.totalPage = res.data.totalPage
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.out_box {
  border-radius: 8px;
  background: #FFFFFF;
  padding: 24px 16px;
  .user_balance {
    color: #A6A6A6;
    span {
      color: #182A35;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .meal_box {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    margin-top: 32px;
    .meal_item {
      // display: flex;
      // flex-direction: column;
      // justify-content: space-between;
      padding: 32px;
      border-radius: 12px;
      border: 1px solid #e0e0e0;
      text-align: center;
      // height: 190px;
      width: 383px;
      // margin-right: 24px;
      // margin-bottom: 16px;
      cursor: pointer;
      .meal_count {
        margin-top: 39px;
        font-size: 20px;
        color: #182A35;
        img {
          margin-right: 8px;
          vertical-align: bottom;
        }
      }
      .meal_price {
        margin-top: 39px;
        font-size: 60px;
        font-weight: 800;
        color: #FF6E2B;
        span {
          font-size: 16px;
          font-weight: 400;
        }
      }
      .meal_oprice {
        font-size: 18px;
        color: #a6a6a6;
        text-decoration: line-through;
      }
      &.active {
        background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
        box-shadow: 0px 0px 8px rgba(80, 148, 207, 0.2);
        .meal_count, .meal_price, .meal_oprice {
          color: #FFFFFF;
        }
      }
    }

  }
  .pay_title {
    color: #A6A6A6;
    margin-top: 24px;
  }
  .pay_box {
    margin-top: 16px;
    display: flex;
    border-radius: 24px;
    border: 1px solid #EDEDED;
    background: rgba(247, 247, 247, 0.3);
    width: 50%;
    min-width: 500px;
    padding: 37px;
    .pay_code {
      width: 140px;
      margin-right: 32px;
    }
    .pay_info {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      color: #808080;
      .pay_price {
        font-size: 20px;
        color: #5C5C5C;
        span {
          color: #FF6E2B;
          font-size: 32px;

        }
      }
      img {
        vertical-align: middle;
        margin-right: 4px;
      }
      .pay_agree {
        color: #858585;
        font-size: 12px;
      }
    }
  }
  .doulist_box {
    margin-top: 32px;
    .dou_btn {
      color: #808080;
      font-size: 14px;
      margin-right: 24px;
      vertical-align: middle;
      cursor: pointer;
      &.dou_btnactive {
        font-size: 16px;
        color: #262626;
      }
    }
    .table_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 80%;
      // gap: 24px;
      div {
        width: 23.5%;
      }
      .table_head {
        border-radius: 4px;
        background: rgba(232, 232, 232, 0.2);
        padding: 17px 24px;
        color: #262626;
        font-size: 16px;
      }
      .table_body {
        margin-top: 24px;
        padding: 0 24px;
        color: #262626;
        font-size: 16px;
      }
    }
    .dou_nomore {
      text-align: center;
      color: #808080;
      margin-top: 32px;
      margin-bottom: 32px;
      font-size: 14px;
      width: 80%;
    }
  }
}
</style>